import { Box, Typography } from "@mui/material";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import { colors } from "@components/ui/colors";
import { AudioPlayerBar } from "@components/shared/components/audio-player/AudioPlayerBar";

interface Props {
  src: string;
  isOutgoing?: boolean;
}

export function AudioMessageBubble({ src, isOutgoing = false }: Props) {
  return (
    <Box
      sx={{
        mt: 1,
        maxWidth: 220,
        borderRadius: "12px",
      }}
    >
      <AudioPlayerBar
        src={src}
        label={
          <Box display="flex" alignItems="center" gap={0.75} mb={0.5}>
            <GraphicEqIcon
              sx={{
                fontSize: 16,
                color: isOutgoing ? colors.orange[700] : colors.orange[400],
              }}
            />
            <Typography
              variant="caption"
              sx={{
                fontWeight: 800,
                fontSize: "0.65rem",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                color: isOutgoing ? colors.orange[900] : "text.secondary",
              }}
            >
              Voice Note
            </Typography>
          </Box>
        }
        playButtonSx={{
          bgcolor: isOutgoing ? colors.orange[500] : colors.orange[100],
          color: isOutgoing ? "white" : colors.orange[700],
          "&:hover": {
            bgcolor: isOutgoing ? colors.orange[600] : colors.orange[200],
          },
          width: 36,
          height: 36,
          boxShadow: isOutgoing ? "0 2px 8px rgba(255, 152, 0, 0.3)" : "none",
        }}
        sliderSx={{
          color: isOutgoing ? colors.orange[500] : colors.orange[400],
          height: 4,
          py: 0.5,
          "& .MuiSlider-thumb": {
            width: 12,
            height: 12,
            "&:hover, &.Mui-focusVisible, &.Mui-active": {
              boxShadow: `0 0 0 8px ${isOutgoing ? colors.orange[100] : "rgba(0,0,0,0.08)"}`,
            },
          },
          "& .MuiSlider-rail": {
            opacity: 1,
            bgcolor: isOutgoing ? colors.orange[100] : colors.gray[300],
          },
          "& .MuiSlider-track": {
            border: "none",
          },
        }}
        timeLabelSx={{
          fontSize: "10px",
          fontWeight: 700,
          color: isOutgoing ? colors.orange[800] : "text.secondary",
        }}
      />
    </Box>
  );
}
